import Clarity from '@microsoft/clarity';
import type { ObservabilityUserContext } from './types';

const TAG = '[observability/clarity]';

let enabled = false;
let initAttempted = false;

export function initClarity(): void {
    if (initAttempted) return;
    initAttempted = true;

    const projectId = import.meta.env.VITE_CLARITY_ID;
    if (!projectId) {
        console.info(`${TAG} VITE_CLARITY_ID not set – Clarity disabled`);
        return;
    }

    Clarity.init(projectId);
    enabled = true;
}

export function setClarityUserContext(ctx: ObservabilityUserContext): void {
    if (!enabled) return;
    Clarity.identify(ctx.userId);
    Clarity.setTag('tenantId', ctx.tenantId);
}

export function trackClarityEvent(name: string): void {
    if (!enabled) return;
    Clarity.event(name);
}
